// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrackingManagement-containerWith-EoAHZ {
    width: 100%;
    max-width: 1260px !important;
    margin: 0 auto;
}

.TrackingManagement-container-maEWT {
    max-width: 100%;
}

/* Text - Start */

.TrackingManagement-subText-aeHlk {
    color: var(--secondary-foreground);
    font-size: 14px;
}

/* Text - End */

/* Header */

.TrackingManagement-navigationLink-bpdSD a {
    padding-right: 20px !important;
    padding-left: 20px !important;
    color: var(--primary-foreground) !important;
    font-size: 18px;
    border-bottom: 2px solid transparent;
}

.TrackingManagement-navigationLink-bpdSD a:hover,
.TrackingManagement-navigationLink-bpdSD a:focus,
.TrackingManagement-navigationLink-bpdSD a:active {
    border-bottom: 2px solid var(--primary-foreground);
}

/* Header */

/* commonCss */

.TrackingManagement-noPadding-th1ax {
    padding: 0;
}

.TrackingManagement-heading-kR0bp {
    padding: 30px 0px 24px 0px;
    font-weight: 700;
    font-size: 24px;
    color: var(--primary-foreground);
}

.TrackingManagement-widthInner-Ol7VI {
    margin: 0px auto 0px auto;
    border-radius: 4px;
    padding: 0px;
    margin: 0px 15px 30px;
}

.TrackingManagement-noMargin-NiI_2 {
    margin: 0;
}

.TrackingManagement-formControlInputTable-u03le {
    border: none;
    width: 100px;
    height: auto;
}

.TrackingManagement-backBtn-lrlgC {
    margin-left: 15px;
    display: inline-block;
}

.TrackingManagement-backBtn-lrlgC:active,
.TrackingManagement-backBtn-lrlgC:hover,
.TrackingManagement-backBtn-lrlgC:focus {
    color: var(--primary-bg);
    text-decoration: none !important;
}

.TrackingManagement-textAlignRight-RX508 {
    text-align: right;
}

.TrackingManagement-displayInlineBlock-HnsGy {
    display: inline-block;
}

.TrackingManagement-displayBlock-Cn3Mz {
    display: block;
}

.TrackingManagement-countryCode-cjxiU {
    width: 15%;
    vertical-align: top;
}

.TrackingManagement-vtrMiddle-ajPjS {
    vertical-align: middle;
}

/* commonCss */

.TrackingManagement-editIcon-LkRuu {
    width: 100%;
    width: 15px;
    vertical-align: middle;
    margin-right: 3px;
}

.TrackingManagement-iconBtn-HxeMz,
.TrackingManagement-iconBtn-HxeMz:hover,
.TrackingManagement-iconBtn-HxeMz:focus {
    padding: 0 !important;
    background: transparent !important;
    color: var(--danger-action-color) !important;
    border: 0 !important;
    white-space: nowrap;
    font-size: 16px !important;
    text-decoration: unset !important;
    cursor: pointer;
}

.TrackingManagement-profileImg-hU7I_ {
    width: 100%;
    height: auto;
    margin-bottom: 18px;
}

.TrackingManagement-profileImgSection-YmfSJ {
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid var(--primary-border);
    background: var(--primary-input-bg);

}

.TrackingManagement-profileImgWidth-R2kD6 {
    margin: 0;
    max-width: 100% !important;
}

.TrackingManagement-searchInput-HGYZR {
    width: 100%;
    max-width: 320px;
}

.TrackingManagement-backgroundImg-Rui8B {
    padding-top: 42%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 18px;
    border-radius: 4px;
    background-color: transparent;
    background-position: center;
    margin-top: 6px;
    border: 1px dashed var(--primary-border);
    border-radius: 12px;
}

/*******************Export CSV section start ******************/

.TrackingManagement-exportDisplay-H27Q_ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    margin-bottom: 18px;
    gap: 18px;
    grid-gap: 18px;
}

.TrackingManagement-exportTextSection-mCNPI {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.TrackingManagement-exportText-oGRv1 {
    display: inline-block;
    padding-right: 5px;
}

.TrackingManagement-exportTextContainer-s82Fa {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    color: var(--primary-link-foreground) !important;
    text-decoration: unset !important;
    border-bottom: 1px solid var(--primary-link-foreground);
}

.TrackingManagement-vtrTextBottom-nDlgN {
    vertical-align: text-bottom;
}

.TrackingManagement-exportImg-xHBQ2 {
    width: 100%;
    max-width: 14px;
    height: 14px;
    -o-object-fit: contain;
       object-fit: contain;
}

/*******************Export CSV section End ******************/

.TrackingManagement-noLink-MRFjX,
.TrackingManagement-noLink-MRFjX:hover {
    color: var(--primary-link-foreground) !important;
    cursor: pointer;
}

.TrackingManagement-singleCard-2TtT7 {
    width: 500px;
    margin: 0 auto;
}

.TrackingManagement-defaultIcon-Fq2Kz {
    background-size: 50px;
}

.TrackingManagement-assignProviderSearchInput-G1m5u {
    width: 100%;
    max-width: 324px;
}

.TrackingManagement-searchGroupContainer-ANNox {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 12px;
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
}

@media (max-width: 767px) {
    .TrackingManagement-searchGroupContainer-ANNox {
        width: 100%;
    }

}

@media (max-width: 1199px) and (min-width: 1024px) {
  .TrackingManagement-widthInner-Ol7VI {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .TrackingManagement-aboutGrid-FTElF img {
    position: relative;
    top: -25px !important;
  }

  .TrackingManagement-responsiveView-wXzXg {
    width: 100% !important;
    max-width: 175px !important;
  }

  .TrackingManagement-positionFive-zhDZG {
    top: 28% !important;
  }

  .TrackingManagement-positionTwo-o4kD7 {
    top: 28% !important;
  }

  .TrackingManagement-responsiveContentOne-X9inx {
    top: -50px !important;
  }

  .TrackingManagement-positionFour-_fikN {
    top: -50px !important;
  }

  .TrackingManagement-totalCss-e4BBB {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .TrackingManagement-navbar-expand-lg-KOvam .TrackingManagement-navbar-toggler-ZR_NA {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .TrackingManagement-profileImgSection-YmfSJ {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .TrackingManagement-navigationLink-bpdSD a {
    color: var(--primary-foreground) !important;
  }

  .TrackingManagement-widthInner-Ol7VI {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .TrackingManagement-responsiveContentOne-X9inx {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .TrackingManagement-positionTwo-o4kD7 {
    top: 24% !important;
    left: -5% !important;
  }

  .TrackingManagement-positionThree-NjrR4 {
    top: 70% !important;
    left: -5% !important;
  }

  .TrackingManagement-positionFour-_fikN {
    top: -42px !important;
    right: -5% !important;
  }

  .TrackingManagement-positionFive-zhDZG {
    top: 20% !important;
    right: -5% !important;
  }

  .TrackingManagement-positionSix-qgkWv {
    top: 70% !important;
    right: -5% !important;
  }

  .TrackingManagement-responsiveView-wXzXg {
    width: 100% !important;
    max-width: 115px !important;
  }

  .TrackingManagement-aboutGrid-FTElF img {
    top: -1px !important;
  }

  .TrackingManagement-contentOne-gzLhk h1 {
    font-size: 16px !important;
  }

  .TrackingManagement-contentOne-gzLhk p {
    font-size: 12px !important;
  }


  .TrackingManagement-totalCss-e4BBB {
    width: 100% !important;
  }

  .TrackingManagement-padding-Yy0nI {
    padding: 0px 0 0 60px !important;
  }

  .TrackingManagement-singleCard-2TtT7 {
    width: 100% !important;
  }

  .TrackingManagement-navigationLink-bpdSD a:hover,
  .TrackingManagement-navigationLink-bpdSD a:focus,
  .TrackingManagement-navigationLink-bpdSD a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .TrackingManagement-navbar-collapse-FEO5u.TrackingManagement-show-HwclR {
    right: 0% !important;
    top: 0 !important;
  }

  .TrackingManagement-navbar-collapse-FEO5u {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .TrackingManagement-content-etqA9 {
    float: none;
  }

  .TrackingManagement-mr-auto-w5f9d.TrackingManagement-navbar-nav-zoKUc {
    padding-bottom: 80px !important;
  }

  .TrackingManagement-navigationLink-bpdSD a {
    color: var(--primary-foreground) !important;
  }

  .TrackingManagement-footer-nlSNu {
    padding: 35px 0 0 15px;
  }

  .TrackingManagement-widthInner-Ol7VI {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .TrackingManagement-responsiveNoPadding-VosCJ {
    padding: 0px !important;
  }

  .TrackingManagement-contentOne-gzLhk {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .TrackingManagement-aboutContainer-WkqVa {
    padding: 30px 0 30px !important;
  }

  .TrackingManagement-noPosition-Oy5D2 {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .TrackingManagement-mobimleImg-sbhLH {
    display: none !important;
  }

  .TrackingManagement-totalCss-e4BBB {
    width: 100% !important;
  }

  .TrackingManagement-imgWidth-P5vTg {
    padding: 18px !important;
  }

  .TrackingManagement-searchInput-HGYZR,
  .TrackingManagement-assignProviderSearchInput-G1m5u {
    max-width: 100% !important;
  }

  .TrackingManagement-exportText-oGRv1 {
    display: inline-block;
  }

  .TrackingManagement-gridSystem-Pqj7r {
    grid-template-columns: auto !important;
  }

  .TrackingManagement-padding-Yy0nI {
    padding: 52px 0 0 0 !important;
  }

  .TrackingManagement-heading-kR0bp {
    padding: 30px 0 24px !important;
  }

  .TrackingManagement-singleCard-2TtT7 {
    width: 100% !important;
  }

  .TrackingManagement-displayGrid-ixO8s {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .TrackingManagement-boxInner-Jvqsp {
    padding: 35px 0 !important;
  }

  .TrackingManagement-navigationLink-bpdSD a:hover,
  .TrackingManagement-navigationLink-bpdSD a:focus,
  .TrackingManagement-navigationLink-bpdSD a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .TrackingManagement-whiteDropdown-nra4P select {
    width: 120px !important;
  }
}

.TrackingManagement-justifyContent-W2ZW_ {
	-webkit-box-pack: start;
	    -ms-flex-pack: start;
	        justify-content: flex-start;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-bottom: 30px;
	row-gap: 15px;
}

.TrackingManagement-mapInfo-s4ujo {
	width: auto;
	height: auto;
	background: var(--background-secondary);
	border-radius: 4px;
	-webkit-box-shadow: 0px 4px 11px #00000029;
	box-shadow: 0px 4px 11px #00000029;
	position: absolute;
	top: 26px;
	right: 26px;
	padding: 14px 14px 2px;
}

.TrackingManagement-relative-G1PrB {
	position: relative;
}

.TrackingManagement-mapInfoHeading-GUlKI {
	color: var(--primary-foreground);
	font-size: 14px;
	font-weight: bold;
	padding-bottom: 5px;
}

.TrackingManagement-mapInfoText-VAy_I {
	font-size: 14px;
	color: var(--primary-foreground);
	padding-left: 7px;
	padding-top: 1px;
}

.TrackingManagement-flex-OPYXM {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	padding-bottom: 8px;
}

.TrackingManagement-flex-OPYXM img {
	width: 18px;
	height: 28px;
}

.TrackingManagement-infoIcon-UT9_R {
	position: absolute;
	top: 0;
	right: 0;
	display: none;
}

.TrackingManagement-infoIcon-UT9_R img {
	width: 60px;
}

.TrackingManagement-recordTop-MLoX0 {
	position: relative;
	top: 13px;
}

.TrackingManagement-trackingBtnGroup-o_jBu {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.TrackingManagement-trackingSelectGroup-QDDBc {
	display: grid;
	grid-template-columns: 2fr 2fr 1fr;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	gap: 12px;
}

@media(max-width:991px) {
	.TrackingManagement-justifyContent-W2ZW_ {
		margin-bottom: 20px;
	}

	.TrackingManagement-infoIcon-UT9_R {
		display: block;
	}

	.TrackingManagement-mapInfo-s4ujo {
		display: none;
	}

	.TrackingManagement-hoverCss-_B9rh:hover .TrackingManagement-mapInfo-s4ujo {
		display: block;
	}

	.TrackingManagement-widthInner-Ol7VI {
		padding: 20px 20px;
	}
}

@media(max-width:767px) {
	.TrackingManagement-widthMb-fTgeq {
		width: 100%;
	}

	.TrackingManagement-trackingBtnGroup-o_jBu {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
	}

	.TrackingManagement-trackingSelectGroup-QDDBc {
		grid-template-columns: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Common.css","webpack://./src/components/responsive-common.css","webpack://./src/components/SiteAdmin/TrackingManagement/TrackingManagement.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;;AACjB;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA,eAAe;;AAEf,WAAW;;AAEX;IACI,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,eAAe;IACf,oCAAoC;AACxC;;AAEA;;;IAGI,kDAAkD;AACtD;;AAEA,WAAW;;AAEX,cAAc;;AACd;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;;AAEd;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;;;IAGI,qBAAqB;IACrB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,mBAAmB;IACnB,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mCAAmC;;AAEvC;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;IACf,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+DAA+D;;AAC/D;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;IACf,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,gDAAgD;IAChD,iCAAiC;IACjC,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA,6DAA6D;;AAC7D;;IAEI,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AC1OA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;ACvPA;CACC,uBAA2B;KAA3B,oBAA2B;SAA3B,2BAA2B;CAC3B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uCAAuC;CACvC,kBAAkB;CAClB,0CAA0C;CAC1C,kCAAkC;CAClC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gCAAgC;CAChC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC;EACC,mBAAmB;CACpB;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;CACvB;;CAEA;EACC,2BAA2B;CAC5B;AACD","sourcesContent":[".containerWith {\n    width: 100%;\n    max-width: 1260px !important;\n    margin: 0 auto;\n}\n\n.container {\n    max-width: 100%;\n}\n\n/* Text - Start */\n.subText {\n    color: var(--secondary-foreground);\n    font-size: 14px;\n}\n\n/* Text - End */\n\n/* Header */\n\n.navigationLink a {\n    padding-right: 20px !important;\n    padding-left: 20px !important;\n    color: var(--primary-foreground) !important;\n    font-size: 18px;\n    border-bottom: 2px solid transparent;\n}\n\n.navigationLink a:hover,\n.navigationLink a:focus,\n.navigationLink a:active {\n    border-bottom: 2px solid var(--primary-foreground);\n}\n\n/* Header */\n\n/* commonCss */\n.noPadding {\n    padding: 0;\n}\n\n.heading {\n    padding: 30px 0px 24px 0px;\n    font-weight: 700;\n    font-size: 24px;\n    color: var(--primary-foreground);\n}\n\n.widthInner {\n    margin: 0px auto 0px auto;\n    border-radius: 4px;\n    padding: 0px;\n    margin: 0px 15px 30px;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.formControlInputTable {\n    border: none;\n    width: 100px;\n    height: auto;\n}\n\n.backBtn {\n    margin-left: 15px;\n    display: inline-block;\n}\n\n.backBtn:active,\n.backBtn:hover,\n.backBtn:focus {\n    color: var(--primary-bg);\n    text-decoration: none !important;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n.displayInlineBlock {\n    display: inline-block;\n}\n\n.displayBlock {\n    display: block;\n}\n\n.countryCode {\n    width: 15%;\n    vertical-align: top;\n}\n\n.vtrMiddle {\n    vertical-align: middle;\n}\n\n/* commonCss */\n\n.editIcon {\n    width: 100%;\n    width: 15px;\n    vertical-align: middle;\n    margin-right: 3px;\n}\n\n.iconBtn,\n.iconBtn:hover,\n.iconBtn:focus {\n    padding: 0 !important;\n    background: transparent !important;\n    color: var(--danger-action-color) !important;\n    border: 0 !important;\n    white-space: nowrap;\n    font-size: 16px !important;\n    text-decoration: unset !important;\n    cursor: pointer;\n}\n\n.profileImg {\n    width: 100%;\n    height: auto;\n    margin-bottom: 18px;\n}\n\n.profileImgSection {\n    width: 100%;\n    margin: 0 auto;\n    padding: 30px;\n    border-radius: 12px;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-input-bg);\n\n}\n\n.profileImgWidth {\n    margin: 0;\n    max-width: 100% !important;\n}\n\n.searchInput {\n    width: 100%;\n    max-width: 320px;\n}\n\n.backgroundImg {\n    padding-top: 42%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    margin-bottom: 18px;\n    border-radius: 4px;\n    background-color: transparent;\n    background-position: center;\n    margin-top: 6px;\n    border: 1px dashed var(--primary-border);\n    border-radius: 12px;\n}\n\n/*******************Export CSV section start ******************/\n.exportDisplay {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-bottom: 18px;\n    gap: 18px;\n    grid-gap: 18px;\n}\n\n.exportTextSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.exportText {\n    display: inline-block;\n    padding-right: 5px;\n}\n\n.exportTextContainer {\n    display: flex;\n    align-items: center;\n    color: var(--primary-link-foreground) !important;\n    text-decoration: unset !important;\n    border-bottom: 1px solid var(--primary-link-foreground);\n}\n\n.vtrTextBottom {\n    vertical-align: text-bottom;\n}\n\n.exportImg {\n    width: 100%;\n    max-width: 14px;\n    height: 14px;\n    object-fit: contain;\n}\n\n/*******************Export CSV section End ******************/\n.noLink,\n.noLink:hover {\n    color: var(--primary-link-foreground) !important;\n    cursor: pointer;\n}\n\n.singleCard {\n    width: 500px;\n    margin: 0 auto;\n}\n\n.defaultIcon {\n    background-size: 50px;\n}\n\n.assignProviderSearchInput {\n    width: 100%;\n    max-width: 324px;\n}\n\n.searchGroupContainer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-grow: 1;\n}\n\n@media (max-width: 767px) {\n    .searchGroupContainer {\n        width: 100%;\n    }\n\n}","@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/Common.css';\n@import '../../../components/responsive-common.css';\n\n\n\n.justifyContent {\n\tjustify-content: flex-start;\n\talign-items: center;\n\tmargin-bottom: 30px;\n\trow-gap: 15px;\n}\n\n.mapInfo {\n\twidth: auto;\n\theight: auto;\n\tbackground: var(--background-secondary);\n\tborder-radius: 4px;\n\t-webkit-box-shadow: 0px 4px 11px #00000029;\n\tbox-shadow: 0px 4px 11px #00000029;\n\tposition: absolute;\n\ttop: 26px;\n\tright: 26px;\n\tpadding: 14px 14px 2px;\n}\n\n.relative {\n\tposition: relative;\n}\n\n.mapInfoHeading {\n\tcolor: var(--primary-foreground);\n\tfont-size: 14px;\n\tfont-weight: bold;\n\tpadding-bottom: 5px;\n}\n\n.mapInfoText {\n\tfont-size: 14px;\n\tcolor: var(--primary-foreground);\n\tpadding-left: 7px;\n\tpadding-top: 1px;\n}\n\n.flex {\n\tdisplay: flex;\n\tpadding-bottom: 8px;\n}\n\n.flex img {\n\twidth: 18px;\n\theight: 28px;\n}\n\n.infoIcon {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tdisplay: none;\n}\n\n.infoIcon img {\n\twidth: 60px;\n}\n\n.recordTop {\n\tposition: relative;\n\ttop: 13px;\n}\n\n.trackingBtnGroup {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.trackingSelectGroup {\n\tdisplay: grid;\n\tgrid-template-columns: 2fr 2fr 1fr;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tgap: 12px;\n}\n\n@media(max-width:991px) {\n\t.justifyContent {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.infoIcon {\n\t\tdisplay: block;\n\t}\n\n\t.mapInfo {\n\t\tdisplay: none;\n\t}\n\n\t.hoverCss:hover .mapInfo {\n\t\tdisplay: block;\n\t}\n\n\t.widthInner {\n\t\tpadding: 20px 20px;\n\t}\n}\n\n@media(max-width:767px) {\n\t.widthMb {\n\t\twidth: 100%;\n\t}\n\n\t.trackingBtnGroup {\n\t\tflex-direction: column;\n\t}\n\n\t.trackingSelectGroup {\n\t\tgrid-template-columns: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerWith": `TrackingManagement-containerWith-EoAHZ`,
	"container": `TrackingManagement-container-maEWT`,
	"subText": `TrackingManagement-subText-aeHlk`,
	"navigationLink": `TrackingManagement-navigationLink-bpdSD`,
	"noPadding": `TrackingManagement-noPadding-th1ax`,
	"heading": `TrackingManagement-heading-kR0bp`,
	"widthInner": `TrackingManagement-widthInner-Ol7VI`,
	"noMargin": `TrackingManagement-noMargin-NiI_2`,
	"formControlInputTable": `TrackingManagement-formControlInputTable-u03le`,
	"backBtn": `TrackingManagement-backBtn-lrlgC`,
	"textAlignRight": `TrackingManagement-textAlignRight-RX508`,
	"displayInlineBlock": `TrackingManagement-displayInlineBlock-HnsGy`,
	"displayBlock": `TrackingManagement-displayBlock-Cn3Mz`,
	"countryCode": `TrackingManagement-countryCode-cjxiU`,
	"vtrMiddle": `TrackingManagement-vtrMiddle-ajPjS`,
	"editIcon": `TrackingManagement-editIcon-LkRuu`,
	"iconBtn": `TrackingManagement-iconBtn-HxeMz`,
	"profileImg": `TrackingManagement-profileImg-hU7I_`,
	"profileImgSection": `TrackingManagement-profileImgSection-YmfSJ`,
	"profileImgWidth": `TrackingManagement-profileImgWidth-R2kD6`,
	"searchInput": `TrackingManagement-searchInput-HGYZR`,
	"backgroundImg": `TrackingManagement-backgroundImg-Rui8B`,
	"exportDisplay": `TrackingManagement-exportDisplay-H27Q_`,
	"exportTextSection": `TrackingManagement-exportTextSection-mCNPI`,
	"exportText": `TrackingManagement-exportText-oGRv1`,
	"exportTextContainer": `TrackingManagement-exportTextContainer-s82Fa`,
	"vtrTextBottom": `TrackingManagement-vtrTextBottom-nDlgN`,
	"exportImg": `TrackingManagement-exportImg-xHBQ2`,
	"noLink": `TrackingManagement-noLink-MRFjX`,
	"singleCard": `TrackingManagement-singleCard-2TtT7`,
	"defaultIcon": `TrackingManagement-defaultIcon-Fq2Kz`,
	"assignProviderSearchInput": `TrackingManagement-assignProviderSearchInput-G1m5u`,
	"searchGroupContainer": `TrackingManagement-searchGroupContainer-ANNox`,
	"aboutGrid": `TrackingManagement-aboutGrid-FTElF`,
	"responsiveView": `TrackingManagement-responsiveView-wXzXg`,
	"positionFive": `TrackingManagement-positionFive-zhDZG`,
	"positionTwo": `TrackingManagement-positionTwo-o4kD7`,
	"responsiveContentOne": `TrackingManagement-responsiveContentOne-X9inx`,
	"positionFour": `TrackingManagement-positionFour-_fikN`,
	"totalCss": `TrackingManagement-totalCss-e4BBB`,
	"navbar-expand-lg": `TrackingManagement-navbar-expand-lg-KOvam`,
	"navbar-toggler": `TrackingManagement-navbar-toggler-ZR_NA`,
	"positionThree": `TrackingManagement-positionThree-NjrR4`,
	"positionSix": `TrackingManagement-positionSix-qgkWv`,
	"contentOne": `TrackingManagement-contentOne-gzLhk`,
	"padding": `TrackingManagement-padding-Yy0nI`,
	"navbar-collapse": `TrackingManagement-navbar-collapse-FEO5u`,
	"show": `TrackingManagement-show-HwclR`,
	"content": `TrackingManagement-content-etqA9`,
	"mr-auto": `TrackingManagement-mr-auto-w5f9d`,
	"navbar-nav": `TrackingManagement-navbar-nav-zoKUc`,
	"footer": `TrackingManagement-footer-nlSNu`,
	"responsiveNoPadding": `TrackingManagement-responsiveNoPadding-VosCJ`,
	"aboutContainer": `TrackingManagement-aboutContainer-WkqVa`,
	"noPosition": `TrackingManagement-noPosition-Oy5D2`,
	"mobimleImg": `TrackingManagement-mobimleImg-sbhLH`,
	"imgWidth": `TrackingManagement-imgWidth-P5vTg`,
	"gridSystem": `TrackingManagement-gridSystem-Pqj7r`,
	"displayGrid": `TrackingManagement-displayGrid-ixO8s`,
	"boxInner": `TrackingManagement-boxInner-Jvqsp`,
	"whiteDropdown": `TrackingManagement-whiteDropdown-nra4P`,
	"justifyContent": `TrackingManagement-justifyContent-W2ZW_`,
	"mapInfo": `TrackingManagement-mapInfo-s4ujo`,
	"relative": `TrackingManagement-relative-G1PrB`,
	"mapInfoHeading": `TrackingManagement-mapInfoHeading-GUlKI`,
	"mapInfoText": `TrackingManagement-mapInfoText-VAy_I`,
	"flex": `TrackingManagement-flex-OPYXM`,
	"infoIcon": `TrackingManagement-infoIcon-UT9_R`,
	"recordTop": `TrackingManagement-recordTop-MLoX0`,
	"trackingBtnGroup": `TrackingManagement-trackingBtnGroup-o_jBu`,
	"trackingSelectGroup": `TrackingManagement-trackingSelectGroup-QDDBc`,
	"hoverCss": `TrackingManagement-hoverCss-_B9rh`,
	"widthMb": `TrackingManagement-widthMb-fTgeq`
};
module.exports = ___CSS_LOADER_EXPORT___;
